/**
 * @import { AnsiPalette } from '../ansi.types.js'
 */

/** @type {AnsiPalette} */
export default {
  foreground: '#2A2B32',
  background: '#F8F8F8',
  'background-hover': '#EEEEEE',
  'background-selected': '#E4E4E4',
  black: '#000000',
  red: '#D13B38',
  green: '#3B813D',
  yellow: '#855504',
  blue: '#315EEE',
  magenta: '#930092',
  cyan: '#0E6FAD',
  white: '#8E8F96',
  'bright-black': '#2A2B32',
  'bright-red': '#D13B38',
  'bright-green': '#3B813D',
  'bright-yellow': '#855504',
  'bright-blue': '#315EEE',
  'bright-magenta': '#930092',
  'bright-cyan': '#0E6FAD',
  'bright-white': '#FFFEFE',
};
